import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { downloadPdfComplete } from '../model/configuratorSlice';
import { ClientName, EndPoints } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { FeatureSelectionUtility } from '../utilities/FeatureSelectionUtility';


export default function DownloadPdfService() {
    const {
        settings, categories,
    } = useSelector(state => state.configurator);
    const { promotionSlug } = useParams();
    const dispatch = useDispatch();

    return useMutation(['downloadPdfQuery'], () => {
        let downloadPdfUrl = `${EndPoints.DownloadPdf}/${promotionSlug}/download-pdf`;
        const featureSelection = FeatureSelectionUtility.CreateFeatureSelectionString(categories);
        downloadPdfUrl = `${downloadPdfUrl}?feature_selection=${featureSelection}`;

        const fileName = `${ClientName}_${settings.name}_borrador.pdf`;
        const config = {
            headers: {
                [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
            },
            responseType: 'blob',
        };
        axios
            .post(downloadPdfUrl, {}, config)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                dispatch(downloadPdfComplete());
            })
            .catch((error) => {
                console.log(error);
                // dispatch(setSnackbarMessage(SnackbarMessages.ConfigurationCodeNotFound));
            });
    });
}
